const BgCircles: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="281"
      height="260"
      viewBox="0 0 281 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.15">
        <circle
          cx="165.779"
          cy="69.3511"
          r="114.185"
          stroke="url(#paint0_linear_367_5552)"
          strokeWidth="8"
        />
        <circle
          cx="166.311"
          cy="69.8817"
          r="148.706"
          stroke="url(#paint1_linear_367_5552)"
          strokeWidth="8"
        />
        <circle
          cx="166.311"
          cy="69.8819"
          r="185.882"
          stroke="url(#paint2_linear_367_5552)"
          strokeWidth="8"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_367_5552"
          x1="51.5947"
          y1="69.3511"
          x2="279.964"
          y2="69.3511"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#B8DCD4"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_367_5552"
          x1="17.6052"
          y1="69.8817"
          x2="315.016"
          y2="69.8817"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#B8DCD4"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_367_5552"
          x1="-19.571"
          y1="69.8819"
          x2="352.193"
          y2="69.8819"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#B8DCD4"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BgCircles;
